import {IEnvironment} from '../app/0-general/types'

export const environment: IEnvironment = {
  production: false,
  businessUrl: 'https://api-businnes-backend-test.bildsamtycke.se/api',
  bankIdGatewayUrl: 'https://api-samtycke-bankid-gw-test.samtycke.net/service',
  dataServiceUrl: 'https://api-samtycke-be-test.samtycke.net/api',
  aud: 'admin.samtycke.net'
}